module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("THREE")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("BURKE’S BASTARDS, THAT was the name some newspaperman came up with after that first foray into Katanga. We lost a lot of men, but others lost more and the newspaper stories certainly helped recruiting. They built Burke up into something of a legend for a while and then forgot him, but then our reputation as an elite corps was secure. There was no more difficulty in finding men and Burke was able to pick and choose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And they were marvellous days—the best I had ever known. Hard living, hard training. I felt my strength then for the first time, tried my courage and found, as I suspect most men do, that I could keep going when afraid which, when you come down to it, is all that really matters.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Burke was never satisfied. During one lull between engagements, he even forced us through paratroop training, dropping over Lumba Airport from an old de Havilland Rapide. A month later we used it for real and parachuted into a mission station in the Kasai just ahead of a force of Simbas. We pushed our way out through a couple of hundred miles of unfriendly bush bringing eight nuns with us.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They made Burke a colonel for that little jaunt and I got a captain’s commission around the time I would have been in my third year at Harvard. Life was good then, full of action and passion as it should be and the money poured in as he had promised it would. Two years later, those of us who were left were lucky to get out in what we stood up in.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Contrary to popular opinion, most mercenaries in the Congo were there for the same reason that young men used to join the Foreign Legion. It was what happened when you experienced the reality that was the trouble. I had seen what was left of settlers who had been quartered on the buzz saw of a lumber mill. I had also known mercenaries who had been in the habit of disposing of prisoners by locking them inside old ammunition boxes and ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("dropping them into Lake Kivu, but only when they were too tired to use them for target practice.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In between the two extremes, I had changed, but Piet Jaeger hadn’t altered in the slightest. He came from the sort of bush town in the Northern Transvaal where they still believed kaffirs didn’t have souls and was one of the few survivors of the original commando.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Strangely enough when one considered his background, Piet was no racialist. He had joined us because the chance of a little action and some money in his pocket contrasted favourably with the family farm and the kind of father who carried a Bible in one hand and a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sjambok")]), _vm._v(" in the other, which he was as likely to use on Piet as the kaffirs who were unfortunate enough to work for him. He had stayed because he worshipped Burke, had followed him gladly to hell and back and would again without a qualm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I watched him now in the mirror as he removed my beard with infinite care, a bronzed young god with close-cropped fair hair, a casting director’s dream for the part of the young S.S. officer tom by conscience who sacrifices himself for the girl in the final scene.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Legrande leaned in the doorway, his amiable peasant face expressionless, a Gauloise drooping ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("beneath the heavy moustache. As I said, most of those who went to the Congo were in search of adventure, but there were exceptions and Legrande was one of them, a killer who destroyed without mercy. An O.A.S. gunman, he’d come to the Congo for sanctuary and in spite of my youth had always shown me a kind of grudging respect. I suspect for my skill at arms, as much as anything else.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Very carefully Piet removed the hot towel and stood back and a stranger stared out at me from the mirror, bones showing in the gaunt, sun-blackened face, dark eyes looking through and beyond, still and quiet, waiting for something to happen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Flesh on your bones, that’s all you need,” Piet said. “Good food and lots of red wine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And a woman,” Legrande said with complete seriousness. “A good woman who knows what she’s about. Balance in all things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Plenty of those in Sicily so they tell me,” Piet said.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("I glanced up at him sharply, but before I could ask him what he meant, a woman appeared from the terrace and hesitated, uncertainty on her face as she looked at us. She was obviously Greek and perhaps thirty or thirty-five. It’s hard to tell with ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("peasant women at that age. She had masses of night-black hair that flowed to her shoulders, an olive skin, the lines just beginning to show, and kind eyes.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Legrande and Piet started to laugh and Piet gave the Frenchman a shove towards the door. “We’ll leave you to it, Stacey.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their laughter still echoed faintly after the door had closed and the woman came forward, and put two clean towels and a white shirt on the bed. She smiled and said something in Greek. It isn’t one of my languages so I tried Italian, remembering they’d been here during the war. That didn’t work and neither did German.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shrugged helplessly and she smiled again and for some reason ruffled my hair as if I were a schoolboy. I was still sitting in front of the dressing table where Piet had shaved me and she was standing very close, her breasts on a level with my face. She wore no perfume, but the dress she had on, a cheap cotton thing, had just been laundered and smelt fresh and clean and womanly, filling me with the kind of ache I had forgotten existed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I watched her cross the room and go out through the window and I took a few very deep breaths. It had been a long time, a hell of a long time and Legrande, as always, had put his finger right on the spot. I took off my robe and started to dress.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("The villa was sited on a hillside a couple of hundred feet above a white sand beach. It was obviously a converted farmhouse and someone had spent a small fortune making it just right.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I sat at a table on the edge of the terrace in the hot sun and the woman appeared with grapefruit and scrambled eggs and bacon on a tray with a very English pot of tea. My favourite breakfast. Burke, of course—he thought of everything. I don’t think I’ve ever tasted anything quite like that meal sitting there on the edge of the terrace looking out over the Aegean to the Cyclades drifting north into the haze.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a curious air of unreality to it all and things carried the knife-edge sharpness of the wrong kind of dream. Where was I? Here or in the Hole?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I closed my eyes briefly, opened them again and found Burke watching me gravely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He wore a faded bush shirt and khaki slacks, an old felt hat leaving his face in shadow, and carried a .22 Martini carbine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Keeping your hand in?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nodded. “I’ve been shooting at anything that moves. It’s that kind of morning. How do you feel?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("“Considerably improved. That doctor you provided pumped me full of one good thing after another. Thanks for the breakfast, by the way. You remembered.”")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve known you long enough, haven’t I?” He smiled, that rare smile of his that almost seemed to melt whatever it was that had frozen up inside, but never quite succeeded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seeing him standing there in the felt hat and bush shirt I was reminded again of that first meeting in Mozambique. He was just the same. Magnificently fit with the physique of a heavyweight wrestler and the energy of a man half his age and yet there were changes—slight, perhaps, but there to be seen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For one thing, the eyes were pouching slightly and there was an edge of flesh to the bones that hadn’t been there before. If it had been anyone else I’d have said they’d been drinking, but liquor was something he’d never shown any interest in—or women, if it came to that. He’d always barely tolerated my own need for both.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("It was when he sat down and removed his sunglasses that I received my greatest shock. The eyes—those fine grey eyes—were empty, clouded with a kind of opaque skin of indifference. For a brief moment when anger had blazed out of them ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("back at Fuad in the labour camp, I had seen the old Sean Burke. Now I seemed to be looking at a man who had become a stranger to himself.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He poured a cup of tea, produced, a pack of cigarettes and lit one, something I’d never seen him do before and the hand that held it trembled very, very slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve taken up a vice or two since you last saw me, Stacey boy,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So it would seem.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was it bad back there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not at first. The prison in Cairo was no worse than you’d expect anywhere. It was the labour camp that wasn’t so good. I don’t think Husseini had been right in his head since Sinai. He thought there was a Jew under every bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked puzzled and I explained. He nodded soberly when I finished. “I’ve seen men go that way before.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was silence for a while as if he couldn’t think of anything to say and I poured another cup of tea and helped myself to one of his cigarettes. The smoke bit into the back of my throat like acid and I choked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He started to rise, immediately concerned. “What is it? What’s wrong?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("I managed to catch my breath and held up the ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("cigarette. “Something I had to manage without back there. It tastes like the first one I ever had. Don’t worry—I’ll persevere.”")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“But why start again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I inhaled for the second time. It tasted rather better and I grinned. “I agree with Voltaire. There are some pleasures it’s well worth shortening life for.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He frowned and tossed his own cigarette over the balustrade as if attempting to right some kind of balance for what I had said went completely against his own expressed beliefs. For him, a man—a real man—was completely self-sufficient, a disciplined creature controlling his environment, subject to no vices, no obsessive needs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sat there now, a slight frown still in place, staring moodily into space, and I watched him closely. Sean Burke, the finest, most complete man-at-arms I had ever known. The eternal soldier, an Achilles without a heel on the surface, and yet there were depths there. As I have said, he seldom smiled for some dark happening had touched him in the past, lived with him still. His spiritual home was still the army, the real army, I was certain of that. By all the rules he should have had a staggeringly successful career in it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("During his brief moment of fame in the Congo, ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("the newspapers had unearthed his past in detail. Born in Eire son of an Anglo-Irish Protestant minister who had fought passionately for the Republic in his day. Burke had joined the Irish Guards at seventeen during the Second World War and had soon transferred to the Parachute Regiment. He’d earned a quick M.C. as a young lieutenant at Arnhem and as a captain in Malaya during the emergency, a D.S.O. and promotion to major. Why then had he resigned? There was no official explanation that made any kind of sense. Burke himself had said at the time that the army had simply got too tame. And yet there had been a story in one paper, cautiously told and full of innuendo, that hinted at another explanation. The possibility of a court-martial had he not resigned that would have sent him from the army utterly disgraced and I remembered again our first meeting at the “Lights of Lisbon.” What was it Lola had said of him? Half a man. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Big in everything except what counts")]), _vm._v(". It was possible. All things were possible in this worst of all possible worlds.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But that was not true, that my real self simply couldn’t accept on a morning like this. It was a beautiful world, this world outside the Hole, a place of warmth and air and light, sweet sounds, sun and colour to dazzle the mind.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("He stood up and leaned on the balustrade, looking out over the sea. “Quite a place, isn’t it?”")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded. “Who owns it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A man called Hoffer—Karl Hoffer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And who might he be when he’s at home?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“An Austrian financier.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can’t say I’ve heard of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You wouldn’t. He isn’t too keen on newspaper publicity.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is he rich?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A millionaire and that’s by my standards, not your Yankee one. As a matter of fact that was his gold you were running the night the Gypos jumped you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Which was an interesting piece of information. Millionaire financiers who indulged in a little gold smuggling on the side were about as rare within my experience as the greater blue-tailed goose. Herr Hoffer sounded like a man of infinite possibilities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where is he now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Palermo,” Burke said and there was a kind of eagerness in his voice as if, by asking, I’d made things easier for him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Which explained Piet’s remark about the girls in Sicily")]), _vm._v(".")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("“When you got me into the plane I asked you ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("where we were going,” I said. “You told me Crete first-stop. Presumably Sicily is the second?”")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“A hundred thousand dollars split four ways plus expenses, Stacey.” He sat down again and leaned across the table, fingers interlocking so tightly when he clasped his hands the knuckles showed white. “How does that sound to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For a contract?” I said. “A contract in Sicily?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nodded. “A week’s work at the most and easily earned with you along.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The whole thing was beginning to fall neatly into place. “By me, you mean Stacey the Sicilian, I presume?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure, I do.” Whenever he got excited the Irish side of him floated to the top like cream on milk. “With your Sicilian background we can’t go wrong. Without you, I honestly think we wouldn’t stand a chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s very interesting,” I said. “But tell me something, Sean. Where would I have been sitting right this minute if this Sicilian business hadn’t come up? If you hadn’t needed me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stared at me, caught at one fixed point in time like a butterfly pinned to a collector’s board, tried to speak and failed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You bastard,” I said. “You can stick your hundred thousand dollars where grandma had the pain.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("His hands came apart, fists clenched, the skin of his face turned milk-white with the speed of a chemical reaction and something stirred in the depths of those grey eyes.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ve come a long way since the ‘Lights of Lisbon,’ haven’t we, colonel?” I got up without waiting for a reply and left him there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the cool shadows of my bedroom, anger possessed me like a living thing and my hands were shaking. There was sweat on my face and I opened the top drawer in the dressing table to search for a handkerchief. Instead I found something else. A pistol—the kind of side-arm I had always carried, a replica of the one the Egyptians had relieved me of on that dark night a thousand years ago—a Smith and Wesson .38 Special with a two inch barrel in an open-sided spring holster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I fastened the holster to my belt slightly forward of the right hip, pulled on a cream-coloured linen jacket I found behind the door and slipped a box of cartridges into one of the pockets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I found a pack of cards on a table in the living room as I knew I would where Legrande and Piet were around, and went out, taking a path down the hillside to the white beach below. One way of re-leasing tension is as good as another, and in any event it was obviously time to see if I’d forgotten anything.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f4467a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter03.vue
// module id = 69
// module chunks = 0